var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card tile is-child"},[_vm._m(0),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)]),_c('footer',{staticClass:"card-footer"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"card-header"},[_c('p',{staticClass:"card-header-title"},[_vm._v("Profile")])])
}]

export { render, staticRenderFns }